/**
 * @ngdoc Controller
 * @name DiagnosticsSettingsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('DiagnosticsSettingsController', DiagnosticsSettingsController);

    /**
     * @constructor
     * @ngInject
     */
    function DiagnosticsSettingsController(
        $log,
        $scope,
        $stateParams,
        ApiService,
        $q,
        InstallationsService,
        locale,
        vrmNotificationsService,
        vrmNotificationType,
    ) {
        $log.info('DiagnosticsSettingsController');

        $scope.loading = true;
        $scope.diagnostics = [];
        $scope.site = {};

        $q.all([
            ApiService.diagnostics($stateParams.id),
            InstallationsService.getInstallation($stateParams.id)
        ]).then(function(result) {
            var installation = result[1];
            var response = result[0];

            $scope.site = installation;
            $scope.loading = false;
            $scope.diagnostics = response.data.records;
        });

        $scope.clipboardSupported = navigator.clipboard && navigator.clipboard.writeText;

        $scope.clipboard = async (row) => {
            try {
                await navigator.clipboard.writeText(row.formattedValue);
                vrmNotificationsService.add({ type: vrmNotificationType.SUCCESS, title: locale.getString('diagnostics.clipboard_copy_success') });
            } catch (e) {
                vrmNotificationsService.add({ type: vrmNotificationType.ERROR, title: locale.getString('diagnostics.clipboard_copy_failed'), message: e.message });
                throw e;
            }
        }
    }
})();
